/**
 * Shared copy for the platform-verified agent count (organizations.show_verified_agent_count
 * / get_org_verified_agent_count). Every surface that shows this figure — the public profile
 * tooltip, the admin toggle line, and the By The Numbers derived tile — pulls from here so the
 * wording can't drift between what an admin is told the number means and what a visitor reads.
 *
 * Deliberately does not compare this figure to the org's admin-curated Team and Leadership
 * roster: the two are drawn from different sets and will routinely disagree in either
 * direction, so the copy explains what the count is rather than inviting a reconciliation.
 */
export const VERIFIED_AGENT_COUNT_DEFINITION =
  "Counts people with a confirmed Compaire relationship at this organization — active membership or an approved affiliation — and may be lower than the organization's total agent count.";

/** Short source line for the By The Numbers derived-tile preview. */
export const VERIFIED_AGENT_COUNT_SOURCE_LABEL = "Platform-derived · Confirmed Compaire relationship";
